import { render } from "./RiepilogoProvvigioniClienti.vue?vue&type=template&id=e85f76ac"
import script from "./RiepilogoProvvigioniClienti.vue?vue&type=script&lang=js"
export * from "./RiepilogoProvvigioniClienti.vue?vue&type=script&lang=js"

import "./RiepilogoProvvigioniClienti.vue?vue&type=style&index=0&id=e85f76ac&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__